export const getBoxes = (state) => state.boxes